"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIPTION_LABEL = void 0;
const SUBSCRIPTION_LABEL = exports.SUBSCRIPTION_LABEL = 'subscription-label';
